import { gql } from "@apollo/client";

export default gql`
  mutation updateTeamMutation(
    $id: Int
    $organizationId: Int
    $addMemberIds: [Int!]
    $removeMemberIds: [Int!]
    $addLeadUserIds: [Int!]
    $removeLeadUserIds: [Int!]
    $title: String
  ) {
    createOrUpdateTeam(
      teamId: $id
      organizationId: $organizationId
      addMemberIds: $addMemberIds
      removeMemberIds: $removeMemberIds
      addLeadUserIds: $addLeadUserIds
      removeLeadUserIds: $removeLeadUserIds
      title: $title
    ) {
      # The People page keeps each person's departments: refresh them there.
      changedLeads {
        id
        ledTeamIds
      }
      team {
        id
        title
        leads {
          id
          name
          avatar
        }
        members {
          totalCount
          edges {
            node {
              id
              name
              avatar
            }
          }
        }
      }
    }
  }
`;
